<template>
<div> 
    <v-card>
        <v-card-title v-html="header">
        </v-card-title>

        <v-card-text :class="$style.vCard">
            <v-form v-model="valid_form" ref="form" v-on:submit.prevent="">
                <div :class="$style.questions" v-html="body"/>
                <div v-html="subtext"/>

                <div v-for="group in question.config.groups" :key="'group_'+group.id" :class="$style.answers">
                    <h3 v-html="group.label[$language()]"></h3>
                    <div>
                        <template v-for="input in group.inputs">
                            <div :key="'group_'+group.id+'input_'+input.id" style='width:200px;float: left;margin: 5px;'>
                                <v-text-field 
                                    :value="value[group.id][input.id]"                               
                                    type="number"
                                    outlined
                                    :clearable="true"
                                    :disabled="disabled[group.id][input.id]"
                                    @keypress="noDecimal($event)"
                                    @change="$event.includes('.') ? 
                                            value[group.id][input.id] = $event.split('.')[0] + '.' + $event.split('.')[1].substring(0,2):
                                            value[group.id][input.id] = $event"
                                    class="number-code-wrapper"   
                                >
                                    <template v-slot:label>
                                        <span v-html="input.label[$language()]" />
                                    </template>
                                </v-text-field>
                                <!-- {{value[group.id][input.id]}} -->
                                <!-- <v-btn v-if="value[group.id][input.id]!=null" @click="controller.clear(group.id,input.id)">Clear</v-btn> -->
                                <v-text-field 
                                    v-if="enableOther[group.id][input.id]" 
                                    :autofocus="true" 
                                    :disabled="!enableOther[group.id][input.id]"
                                    @keyup="other[group.id][input.id] ? other[group.id][input.id] = other[group.id][input.id].trimStart() : other[group.id][input.id]" 
                                    v-model="other[group.id][input.id]" 
                                    >
                                    <template v-slot:label>
                                        <str index='survey > label please_specify' />
                                    </template>
                                </v-text-field>
                            </div>
                        </template>
                    </div>
                    
                    <div style="clear:both; "/>
                </div>
            </v-form>
        </v-card-text>

        <v-card-text v-html="footer">
        </v-card-text>
    </v-card>
</div>
</template>

<script>
const controller = require("./controllers/number.js").default;
const module_generator = require("./controllers/module_generator.js").default;

var module_config = module_generator('number-question',controller);
module_config.methods.allowed_decimal = function() {
    if(this.question.config.type_modifer['Number']) {
        var allowed_decimal = this.question.config.type_modifer['Number']['allowed_decimal'];
        return allowed_decimal;
    } 
    return false
}

module_config.methods.noDecimal = function(e) {
    if (this.allowed_decimal()) {
        return true;
    }
    if(e.charCode >= 48 && e.charCode <= 57) {
        return true;
    }
    return e.preventDefault();
}
export default module_config
</script>

<style module>
.vCard {
    padding: 19px 140px;
    width: 100%;
}

.answers {
    margin: 8px -15px;
    padding: 11px;
}

.question{
    border: 1px solid slategray;
    border-radius: 3px;
    margin: 25px;
    padding: 15px;
}

.questions {
    font-size:18px;
    color:black;
}

@media only screen and (max-width: 1240px) {
    .vCard {
        padding: 0 100px;
    }
}

@media only screen and (max-width: 1145px) {
    .vCard {
        padding: 0 80px;
    }
}

@media only screen and (max-width: 1105px) {
    .vCard {
        padding: 0 30px;
    }
}

@media only screen and (max-width: 1000px) {
    .vCard {
        padding: 0 10px;
    }
}

@media only screen and (max-width: 980px) {

.questions {
    width: 95%;
}

.vCard {
    margin: 0px !important;
    width: 100%;
    padding: 0px 10px;
}

.answers {
    margin:0px !important;
    padding: 11px 0px 0px;
}
}
</style>

<style >

.number-code-wrapper .v-input__append-inner {
    margin-top: 8px !important;
}
</style>